import React from 'react';

// third-party
import { useTranslation } from 'react-i18next';

type Props = {
  id?: any;
  defaultMessage?: React.ReactNode;
};

// ==============================|| COMPONENT: SAFE TRANSLATED MESSAGE ||============================== //

// Tiny shim around react-i18next that preserves the previous react-intl API used by
// menu items, breadcrumbs, etc. If the key resolves to a translation, render it;
// otherwise fall back to defaultMessage or the raw id.
export default function SafeFormattedMessage({ id, defaultMessage }: Props) {
  const { t } = useTranslation();

  if (typeof id === 'string' && id.trim().length > 0) {
    const translated = t(id, { defaultValue: '' });
    if (translated && translated !== id) return <>{translated}</>;
  }

  if (defaultMessage) return <>{defaultMessage}</>;
  if (id !== undefined && id !== null) return <>{String(id)}</>;
  return <></>;
}
